import React from 'react';
import MatchHistoryTable from '../MatchHistoryTable';
import { HISTORY_MODE_FILTERS, HISTORY_RANGE_FILTERS } from './constants';

const labelStyle = {
  display: 'block',
  fontSize: 11,
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  color: '#a1a1aa',
  marginBottom: 6,
};

const selectStyle = {
  minWidth: 180,
  borderRadius: 8,
  border: '1px solid #3f3f46',
  background: '#121018',
  color: '#e4e4e7',
  padding: '8px 10px',
};

const MatchHistoryTab = ({
  historyModeFilter,
  setHistoryModeFilter,
  historyMapFilter,
  setHistoryMapFilter,
  historyRangeFilter,
  setHistoryRangeFilter,
  availableHistoryMaps,
  filteredMatchHistory,
  historySummary,
  recentTrend,
  historyLoading,
  historyError,
}) => {
  const summaryCards = [
    { label: 'Average Kills', value: historySummary?.avgKills ?? '--' },
    { label: 'Average Deaths', value: historySummary?.avgDeaths ?? '--' },
    { label: 'Average Assists', value: historySummary?.avgAssists ?? '--' },
    { label: 'Average Score', value: historySummary?.avgScore ?? '--' },
    { label: 'K/D', value: historySummary?.kd ?? '--' },
  ];

  return (
    <section>
      {recentTrend && (
        <div className="recent-form-panel">
          <div className="recent-form-header">
            <div>
              <span>Recent Form</span>
              <small>{recentTrend.title}</small>
            </div>
          </div>
          <div className="recent-form-grid">
            {recentTrend.items.map((item) => (
              <div key={item.key} className={`recent-form-card trend-${item.direction}`}>
                <span className="recent-form-label">{item.label}</span>
                <strong>{item.value}</strong>
                <span className="recent-form-delta">
                  {item.direction === 'up' ? '^ ' : item.direction === 'down' ? 'v ' : '- '}
                  {item.text}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 10, marginBottom: 14 }}>
        {summaryCards.map((card) => (
          <div key={card.label} style={{ borderRadius: 12, border: '1px solid rgba(63, 63, 70, 0.9)', background: '#121018', padding: '12px' }}>
            <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#a1a1aa' }}>{card.label}</div>
            <div style={{ marginTop: 8, fontSize: 22, fontWeight: 700, color: '#fff' }}>{card.value}</div>
          </div>
        ))}
      </div>

      <div style={{ marginBottom: 12, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <div>
          <label style={labelStyle}>Mode</label>
          <select value={historyModeFilter} onChange={(e) => setHistoryModeFilter(e.target.value)} style={selectStyle}>
            {HISTORY_MODE_FILTERS.map((opt) => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
          </select>
        </div>
        <div>
          <label style={labelStyle}>Map</label>
          <select value={historyMapFilter} onChange={(e) => setHistoryMapFilter(e.target.value)} style={selectStyle}>
            <option value="ALL">All Maps</option>
            {availableHistoryMaps.map((mapName) => <option key={mapName} value={mapName}>{mapName}</option>)}
          </select>
        </div>
        <div>
          <label style={labelStyle}>Range</label>
          <select value={historyRangeFilter} onChange={(e) => setHistoryRangeFilter(e.target.value)} style={selectStyle}>
            {HISTORY_RANGE_FILTERS.map((opt) => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
          </select>
        </div>
      </div>

      <MatchHistoryTable matches={filteredMatchHistory} loading={historyLoading} error={historyError} />
    </section>
  );
};

export default MatchHistoryTab;
